module.exports = __webpack_public_path__ + "static/img/wx.3136d093.png";